import React from 'react';
import css from './SchoolsCTABannerV2.module.css';
import schoolsEntry from '../../../images/schools-entry.png';

const FEATURES = [
  'Computer-Based Testing (CBT) delivery',
  'AI-powered question generation',
  'Real-time results & analytics',
  'Multi-class & multi-subject support',
  'Automated grading & term reports',
  'Secure, timed exam environment',
  'CA, Test & Exam categorisation',
  'Student & teacher dashboards',
];

export default function SchoolsCTABannerV2() {

  return (
    <div className={css.wrapper}>
      <div className={css.banner}>

        {/* Floating badge */}
        <div className={css.badge}>
          <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
            <path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6z"/>
          </svg>
          Now Live — Schools CBT Platform
        </div>

        <div className={css.inner}>

          {/* ── Left: text content ── */}
          <div>
            <p className={css.label}>Bubble AI Schools</p>
            <h2 className={css.heading}>
              <span className={css.headingSub}>The Next-Generation</span>
              <span className={css.headingMain}>CBT Exam Engine</span>
            </h2>
            <p className={css.subheading}>
              Empower your school with a super-intelligent Computer-Based Testing platform — Exam management,
              AI question generation, external mock exams and simulations, instant results, deep analytics and career path prediction, all in one place.
            </p>

            <ul className={css.features}>
              {FEATURES.map(f => (
                <li key={f} className={css.featureItem}>
                  <span className={css.check}>✓</span>
                  {f}
                </li>
              ))}
            </ul>

            <div className={css.ctaRow}>
              <a
                href="/school"
                target="_blank"
                rel="noreferrer"
                className={css.ctaBtn}
              >
                Get Your School Started
                <span className={css.ctaArrow}>→</span>
              </a>
              <span className={css.ctaNote}>Free demo available · No payment required</span>
            </div>
          </div>

          {/* ── Right: animated orb with image ── */}
          <div className={css.orbWrap}>
            <div className={css.orb}>
              <img
                src={schoolsEntry}
                alt="Bubble AI Schools"
                className={css.orbImage}
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
